module.exports = __webpack_public_path__ + "img/15.66fd26f2.svg";